<div class="review-container">
  <!-- <section class="error-message" *ngIf="showError" >
    <div class="left">
      <i class="icon-badgealert"></i> -->
      <!--<img src="assets/img/Icon-cross.png" alt="Alert">-->
    <!-- </div>
    <div class="right">
      We are unable to process your report at this time. Please try again later.</div>
  </section> -->

  <div *ngIf="showError" class="alert valign-children-middle error-container" >
    <div class="alert-error" role="img">
      <i class="icon-badgealert" aria-label="alert"></i>
    </div>
    <div>We are unable to process your report at this time. Please try again later.</div>
  </div>

  <p *ngIf="!showError">
    Review your selections to make sure they're correct. To modify an item, click Change.
  </p>
  <section class="outer">
    <div> Foundation account</div>
    <label id="fan">{{fan}} </label>
    <span *ngIf="!singleDevice"><label class="separator">| </label>
    <a href="reports/transaction/reportType">Change</a></span>
  </section>

  <section class="outer" *ngIf="singleDevice">
    <div> Device </div>
    <label>{{selectedCtn}} </label>
    <label class="separator">| </label>
    <a href="reports/transaction/reportType">Change</a>
  </section>

  <section class="outer">
    <div> {{dateRange}}</div>
    <label>
{{startDate}} - {{endDate}} </label>
    <label class="separator">| </label>
    <a href="reports/transaction/dateRange">Change</a>
  </section>

  <section class="outer" *ngIf="!showReportSelection">
    <div> Report format </div>
    <label>{{format}} </label>
    <label class="separator">| </label>
    <a href="javascript:void(0)" id="changeFormat"(click)="selectReportFormat()">Change</a>
  </section>

  <section class="outer" *ngIf="showReportSelection" id="editOptions">
    <div>Select report file format</div>
    <div>Please select the type of file you would like to receive via email. Excel or PDF document</div>
    <div class="radio">
      <label for="Excel document (XLS)"> <input type="radio" id ="Excel document (XLS)"value="Excel document (XLS)" name="format" [(ngModel)]="format">
      <i class="skin"></i><span> Excel document (XLS)</span>
      </label></div><br>
    <div class="radio">
      <label for="PDF"><input type="radio" id="PDF" value="PDF" name="format" [(ngModel)]="format">
      <i class="skin"></i><span>PDF</span>
      </label></div>
  </section>

  <section class="buttons-section col-sm-12 col-md-12 text-right cta">

      <button id="transaction-review-btn" checkImpersonator  (click)="doRequestReport()" 
      class="btn btn-secondary pull-right" attr.aria-label="Request Report">Request report</button>

    <!-- <a href="javascript:void(0)" role="button" class="btn btn-secondary pull-right" 
    id="transaction-review-btn" checkImpersonator (click)="doRequestReport()" attr.aria-label="Request Report">Request Report</a> -->

    <a href="#" (click)="backToPrevious($event)" class="btn btn-link btn-block btn-cancel" attr.aria-label="Back">Back</a>
  </section>
  <div class="clearfix"></div>

</div>